import { render, staticRenderFns } from "./ljzxDialog.vue?vue&type=template&id=d8052310&scoped=true"
import script from "./ljzxDialog.vue?vue&type=script&lang=js"
export * from "./ljzxDialog.vue?vue&type=script&lang=js"
import style0 from "./ljzxDialog.vue?vue&type=style&index=0&id=d8052310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8052310",
  null
  
)

export default component.exports